import { useEffect, useState,useContext } from "react";
import CustomTable_v1 from "./CustomTable_v1";
import { UserService } from "../services/UserService";
import {
  ColumnDefinition,
  ShowError,
  ProgressBar,
  MultiViewPopup,
} from "./UIComponents";
import { isEmpty } from "./Util";
import DashBoardToolBar from "../toolBar/DashBoardToolBar";
import { BaseInquiryToolBar, BaseToolBar } from "../modules/BaseModule";
import { REFRESHICON } from "./Icons";
import { Button } from "react-bootstrap";
import { Loader } from "react-bootstrap-typeahead";
import { ConfigManager } from "../config/ConfigManager";
import { CreditMemoService } from "../services/CreditMemoService";
import {
  PopupInvoiceModule,
  PopupPickTicketModule,
  PopupSalesModule,
  PopupCustomerModule,
  PopupPurchaseOrderModule,
  PopupVendorModule,
  PopupPurchaseInTransitModule,
  PopupPurchaseReceiptModule,
  PopupFabricModule,
   PopupCreditMemoModule,
} from "../modules/ModuleUtil";
import { RefreshCw } from "lucide-react";
import {RestReadRequest} from "../ds/ds"
//import { AppContext } from "../../AppContext.js";
import { AppContext } from "../AppContext";
import { ModuleUtils } from "../modules/ModuleUtils";
export default function DashBoard() {
   const { appData } = useContext(AppContext);

  const companyCode = appData.companyCode;
  const title = "DashBoard";
  const [is3PL, setIs3PL] = useState(false);
  const [salesApproval, setSalesApproval] = useState([]);
  const [salesUnApproval, setSalesUnApproval] = useState([]);
  const [invoiceUnApproval, setInvoiceUnApproval] = useState([]);
  const [purchaseApproval, setpurchaseApproval] = useState([]);
  const [purchaseUnApproval, setpurchaseUnApproval] = useState([]);
  const [purchaseIntransitUnApproval, setPurchaseIntransitUnApproval] =
    useState([]);
  const [purchaseReceiptUnApproval, setPurchaseReceiptUnApproval] = useState(
    [],
  );
  const [logisticOrderApproval, setLogisticOrderApproval] = useState([]);
  const [logisticOrderUnApproval, setLogisticOrderUnApproval] = useState([]);
  const [logisticReceiptUnApproval, setLogisticReceiptUnApproval] = useState(
    [],
  );
  const [dasboardSummary, setDashboardSummary] = useState([]);
  const [currentAts, setCurrentAts] = useState([]);

  const [lateCustomerPayment, setLateCustomerPayment] = useState([]);

  const [packedNotInvoiceList, setPackedNotInvoiceList] = useState([]);

  const [shippedNotInvoiceList, setShippedNotInvoiceList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isShowProgressBarPopup, setIsShowProgressBarPopup] = useState(false);
  const [progressLoadingText, setProgressLoadingText] = useState();

  const [isShowSalesModule, setIsShowSalesModule] = useState(false);
  const [isShowInvoiceModule, setIsShowInvoiceModule] = useState(false);
  const [isShowPtModule, setIsShowPtModule] = useState(false);

  const [isShowCustomerModule, setIsShowCustomerModule] = useState(false);
  const [isShowPurchaseModule, setIsShowPurchaseModule] = useState(false);
  const [isShowVendorModule, setIsShowVendorModule] = useState(false);

  const [isShowIntransitModule, setIsShowIntransitModule] = useState(false);

  const [isShowReceiptModule, setIsShowReceiptModule] = useState(false);

  const [isShowFabricModule, setIsShowFabricModule] = useState(false);

  const [moduleForPopup, setModuleForPopup] = useState([]);

  // const [isLoading, setIsLoading] = useState(false);

  const [isLoadingLateCustomer, setIsLoadingLateCus] = useState(false);

  const [isLoadingSalesApproval, setIsLoadingSal_Approval] = useState(false);

  const [isSummaryLoading, setIsSummaryLoading] = useState(false);

  const [isPackedLoading, setIsPackedLoading] = useState(false);
  const [isShippedLoading, setIsShippedLoading] = useState(false);
  const [isInvoice_UnApp, setIsInvoice_UnAppLoading] = useState(false);
  const [isPurchase_App, setIsPurchase_AppLoading] = useState(false);
  const [isPurchase_UnApp, setIsPurchase_UnAppLoading] = useState(false);

  const [isPurchase_Intransit, setIsPurchase_IntransitLoading] =
    useState(false);

  const [isPurchase_Receipt, setIsPurchase_ReceiptLoading] = useState(false);


  const [showCreditMemoDetails, setCreditMemoPopup] = useState(false);

    const [creditMemoSummaryList, setCreditMemoSummary] = useState([]);
      const [isShowCreditMemoPopup, setIsShowCreditMemoModule] = useState(false);

const [loadingPct, setLoadingPct] = useState(0);
const CIRCUMFERENCE = 2 * Math.PI * 34; // r=34
  useEffect(() => {
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      setIs3PL(true);
    }
  }, []);

  useEffect(() => {
  if (!isSummaryLoading) { setLoadingPct(0); return; }
  setLoadingPct(0);
  const iv = setInterval(() => {
    setLoadingPct(p => {
      const next = Math.min(p + Math.random() * 3 + 1, 94);
      return next;
    });
  }, 120);
  return () => clearInterval(iv);
}, [isSummaryLoading]);
useEffect(()=>{
    ModuleUtils.getCreditMemoStatusList();
})

  const errorCallBack = (error) => {
    setIsLoading(false);
    ShowError("Error :", error);
    setIsLoadingLateCus(false);

    setIsLoadingSal_Approval(false);
    setIsSummaryLoading(false);
    setIsPackedLoading(false);
    setIsShippedLoading(false);
    setIsInvoice_UnAppLoading(false);
    setIsPurchase_AppLoading(false);
    setIsPurchase_UnAppLoading(false);
    setIsPurchase_IntransitLoading(false);
    setIsPurchase_ReceiptLoading(false);
  };
  const loadSalesApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let approvalContants = response.data.contentBean.approvalContents;
      if (
        !isEmpty(approvalContants) &&
        !isEmpty(approvalContants.salesOrderApprovals)
      ) {
        let salesOrderApprovals = new Array();
        salesOrderApprovals = approvalContants.salesOrderApprovals;
        setSalesApproval(salesOrderApprovals);
      }
    }
    setIsLoadingSal_Approval(false);
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
  };
  const loadSalesApprovalPage = () => {
    setIsLoadingSal_Approval(true);
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading SalesOrder Approval");

    UserService.getDashBoardSalesOrderApprovalContents(
      "",
      loadSalesApprovalResponse,
      errorCallBack,
    );
  };

  const loadSalesUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.salesOrderUnApprovals)
      ) {
        let salesOrderUnApprovals = new Array();
        salesOrderUnApprovals = unApprovalContents.salesOrderUnApprovals;
        setSalesUnApproval(salesOrderUnApprovals);
      }
    }
    setIsLoading(false);
    setIsShowProgressBarPopup(false);
    setProgressLoadingText("");
  };
  const loadSalesUnApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    setIsLoading(true);
    // setProgressLoadingText("Loading SalesOrder UnApproval");
    UserService.getDashBoardSalesOrderUnApprovalContents(
      "",
      loadSalesUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadInvoiceUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.approvalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.invoiceUnApprovals)
      ) {
        let invoiceUnApprovals = new Array();
        invoiceUnApprovals = unApprovalContents.invoiceUnApprovals;
        setInvoiceUnApproval(invoiceUnApprovals);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");

    setIsInvoice_UnAppLoading(false);
  };
  const loadInvoiceUnApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading Invoice UnApproval");
    setIsInvoice_UnAppLoading(true);
    UserService.getDashBoardInvoiceUnApprovalContents(
      "",
      loadInvoiceUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadPurchaseApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let approvalContents = response.data.contentBean.approvalContents;
      if (
        !isEmpty(approvalContents) &&
        !isEmpty(approvalContents.purchaseOrderApprovals)
      ) {
        let purchaseApprovals = new Array();
        purchaseApprovals = approvalContents.purchaseOrderApprovals;
        setpurchaseApproval(purchaseApprovals);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
    setIsPurchase_AppLoading(false);
  };
  const loadPurchaseOrderApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading PurchaseOrder Approval");
    setIsPurchase_AppLoading(true);
    UserService.getDashBoardPurchaseOrderApprovalContents(
      "",
      loadPurchaseApprovalResponse,
      errorCallBack,
    );
  };

  const loadPurchaseUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.purchaseOrderUnApprovals)
      ) {
        let purchaseUnApprovals = new Array();
        purchaseUnApprovals = unApprovalContents.purchaseOrderUnApprovals;
        setpurchaseUnApproval(purchaseUnApprovals);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
    setIsPurchase_UnAppLoading(false);
  };
  const loadPurchaseOrderUnApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading PurchaseOrder UnApproval");
       setIsPurchase_UnAppLoading(true);
    UserService.getDashBoardPurchaseOrderUnApprovalContents(
      "",
      loadPurchaseUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadPurchaseIntransitUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.purchaseInTransitUnApprovals)
      ) {
        let purchaseUnApprovals = new Array();
        purchaseUnApprovals = unApprovalContents.purchaseInTransitUnApprovals;
        setPurchaseIntransitUnApproval(purchaseUnApprovals);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
    setIsPurchase_IntransitLoading(false);
  };
  const loadPurchaseIntransitUnApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading Purchase Intransit UnApproval");
    setIsPurchase_IntransitLoading(true);
    UserService.getDashBoardPurchaseInTransitUnApprovalContents(
      "",
      loadPurchaseIntransitUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadPurchaseReceiptUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.purchaseOrderReceiptUnApprovals)
      ) {
        let purchaseUnApprovals = new Array();
        purchaseUnApprovals =
          unApprovalContents.purchaseOrderReceiptUnApprovals;
        setPurchaseReceiptUnApproval(purchaseUnApprovals);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
    setIsPurchase_ReceiptLoading(false);
  };
  const loadPurchaseReceiptUnApprovalPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading Purchase Receipt UnApproval");
    setIsPurchase_ReceiptLoading(true);
    UserService.getDashBoardPurchaseOrderReceiptUnApprovalContents(
      "",
      loadPurchaseReceiptUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadLogisticOrderApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let approvalContents = response.data.contentBean.approvalContents;
      if (
        !isEmpty(approvalContents) &&
        !isEmpty(approvalContents.logisticOrderApprovals)
      ) {
        let logisticApprovals = new Array();
        logisticApprovals = approvalContents.logisticOrderApprovals;
        setLogisticOrderApproval(logisticApprovals);
      }
    }
    setIsShowProgressBarPopup(false);
    setProgressLoadingText("");
  };
  const loadLogisticOrderApprovalPage = () => {
    setIsShowProgressBarPopup(true);
    setProgressLoadingText("Loading Inbound Approval");
    UserService.getDashBoardLogisticOrderApprovalContents(
      "",
      loadLogisticOrderApprovalResponse,
      errorCallBack,
    );
  };

  const loadLogisticOrderUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.logisticOrderUnApprovals)
      ) {
        let logisticUnApprovals = new Array();
        logisticUnApprovals = unApprovalContents.logisticOrderUnApprovals;
        setLogisticOrderUnApproval(logisticUnApprovals);
      }
    }
    setIsShowProgressBarPopup(false);
    setProgressLoadingText("");
  };
  const loadLogisticOrderUnApprovalPage = () => {
    setIsShowProgressBarPopup(true);
    setProgressLoadingText("Loading Inbound UnApproval");
    UserService.getDashBoardLogisticOrderUnApprovalContents(
      "",
      loadLogisticOrderUnApprovalResponse,
      errorCallBack,
    );
  };

  const loadLogisticReceiptUnApprovalResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let unApprovalContents = response.data.contentBean.unApprovalContents;
      if (
        !isEmpty(unApprovalContents) &&
        !isEmpty(unApprovalContents.logisticOrderReceiptUnApprovals)
      ) {
        let logisticReceiptUnApprovals = new Array();
        logisticReceiptUnApprovals =
          unApprovalContents.logisticOrderReceiptUnApprovals;
        setLogisticReceiptUnApproval(logisticReceiptUnApprovals);
      }
    }
    setIsShowProgressBarPopup(false);
    setProgressLoadingText("");
  };
  const loadLogisticReceiptUnApprovalPage = () => {
    setIsShowProgressBarPopup(true);
    setProgressLoadingText("Loading InboundReceipt UnApproval");
    UserService.getDashBoardLogisticOrderReceiptUnApprovalContents(
      "",
      loadLogisticReceiptUnApprovalResponse,
      errorCallBack,
    );
  };

  // const loadCurrentAtsPageResponse = (response) => {
  //   if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
  //     let fabricAts = response.data.contentBean.fabricATSContentBean;
  //     if (!isEmpty(fabricAts) && !isEmpty(fabricAts.fabricATSContentBean)) {
  //       let fabricATSContent = new Array();
  //       fabricATSContent = fabricAts.fabricATSContentBean;
  //       setCurrentAts(fabricATSContent);
  //     }
  //   }
  //   setIsShowProgressBarPopup(false);
  //   setProgressLoadingText("");
  // };
  // const loadCurrentAtsPage = () => {
  //   setIsShowProgressBarPopup(true);
  //   setProgressLoadingText("Loading Current ATS");
  //   UserService.getDashBoardFabricStyleCurrentATSInfos(
  //     "",
  //     loadCurrentAtsPageResponse,
  //     errorCallBack
  //   );
  // };

  const loadLateCustomerPaymentPageResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      let dueCustomer = response.data.contentBean.dueCustomerInvoiceContentBean;
      if (!isEmpty(dueCustomer) && !isEmpty(dueCustomer.dueInvoices)) {
        let dueCustomerContent = new Array();
        dueCustomerContent = dueCustomer.dueInvoices;
        setLateCustomerPayment(dueCustomerContent);
      }
    }
    setIsLoadingLateCus(false);
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
  };
  const loadLateCustomerPaymentPage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading LateCustomer 30Days Due Payment...");
    setIsLoadingLateCus(true);

    UserService.getDashBoardDueInvoiceContents(
      "",
      loadLateCustomerPaymentPageResponse,
      errorCallBack,
    );
  };

  const loadPackedNotInvoiceResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      if (!isEmpty(response.data.contentBean.packedNotInvoicedContentBean)) {
        let packedNotInvoiceContents =
          response.data.contentBean.packedNotInvoicedContentBean;
        let packedList = new Array();
        if (!isEmpty(packedNotInvoiceContents.pickedNotInvoiceInfoBean)) {
          packedList = packedNotInvoiceContents.pickedNotInvoiceInfoBean;
        }

        setPackedNotInvoiceList(packedList);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");

    setIsPackedLoading(false);
  };

  //loadShippedNotInvoiceResponse

  const loadShippedNotInvoiceResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      if (!isEmpty(response.data.contentBean.packedNotInvoicedContentBean)) {
        let packedNotInvoiceContents =
          response.data.contentBean.packedNotInvoicedContentBean;
        let packedList = new Array();
        if (!isEmpty(packedNotInvoiceContents.pickedNotInvoiceInfoBean)) {
          packedList = packedNotInvoiceContents.pickedNotInvoiceInfoBean;
        }

        setShippedNotInvoiceList(packedList);
      }
    }
    // setIsShowProgressBarPopup(false);
    // setProgressLoadingText("");
    setIsShippedLoading(false);
  };
  const loadPackedNotInvoicePage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading Packed Not Invoiced List");
    setIsPackedLoading(true);
    UserService.getDashBoardPackedAndNotInvoiceListInfos(
      "",
      loadPackedNotInvoiceResponse,
      errorCallBack,
    );
  };

  const loadShippedNotInvoicePage = () => {
    // setIsShowProgressBarPopup(true);
    // setProgressLoadingText("Loading Packed Not Invoiced List");
    setIsShippedLoading(true);
    UserService.getDashBoardShippedAndNotInvoiceListInfos(
      "",
      loadShippedNotInvoiceResponse,
      errorCallBack,
    );
  };

  const loadDashboardResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.contentBean)) {
      if (!isEmpty(response.data.contentBean.approvalContents)) {
        let approvalContents = response.data.contentBean.approvalContents;

        if (!isEmpty(approvalContents.salesOrderApprovals)) {
          setSalesApproval(approvalContents.salesOrderApprovals);
        }
        if (!isEmpty(approvalContents.salesOrderUnApprovals)) {
          setSalesUnApproval(approvalContents.salesOrderUnApprovals);
        }
        if (!isEmpty(approvalContents.invoiceUnApprovals)) {
          setInvoiceUnApproval(approvalContents.invoiceUnApprovals);
        }
        if (!isEmpty(approvalContents.purchaseOrderApprovals)) {
          setpurchaseApproval(approvalContents.purchaseOrderApprovals);
        }
        if (!isEmpty(approvalContents.purchaseOrderUnApprovals)) {
          setpurchaseUnApproval(approvalContents.purchaseOrderUnApprovals);
        }
        if (!isEmpty(approvalContents.purchaseInTransitUnApprovals)) {
          setPurchaseIntransitUnApproval(
            approvalContents.purchaseInTransitUnApprovals,
          );
        }
        if (!isEmpty(approvalContents.purchaseOrderReceiptUnApprovals)) {
          setPurchaseReceiptUnApproval(
            approvalContents.purchaseOrderReceiptUnApprovals,
          );
        }
        if (!isEmpty(approvalContents.logisticOrderApprovals)) {
          setLogisticOrderApproval(approvalContents.logisticOrderApprovals);
        }
        if (!isEmpty(approvalContents.logisticOrderUnApprovals)) {
          setLogisticOrderUnApproval(approvalContents.logisticOrderUnApprovals);
        }
        if (!isEmpty(approvalContents.logisticOrderReceiptUnApprovals)) {
          setLogisticReceiptUnApproval(
            approvalContents.logisticOrderReceiptUnApprovals,
          );
        }
        if (!isEmpty(response.data.contentBean.summaryBean)) {
          setDashboardSummary(response.data.contentBean.summaryBean);
        }
      }

      // if (!isEmpty(response.data.contentBean.fabricATSContentBean)) {
      //   let fabricATSContentBean =
      //     response.data.contentBean.fabricATSContentBean;
      //   if (!isEmpty(fabricATSContentBean.fabricCurrentAtsInfoBeans)) {
      //     setCurrentAts(fabricATSContentBean.fabricCurrentAtsInfoBeans);
      //   }
      // }
      if (!isEmpty(response.data.contentBean.dueCustomerInvoiceContentBean)) {
        let dueCustomerInvoiceContentBean =
          response.data.contentBean.dueCustomerInvoiceContentBean;

        if (!isEmpty(dueCustomerInvoiceContentBean.dueInvoices)) {
          setLateCustomerPayment(dueCustomerInvoiceContentBean.dueInvoices);
        }
      }
      if (!isEmpty(response.data.contentBean.packedNotInvoicedContentBean)) {
        let packedNotInvoiceContentBean =
          response.data.contentBean.packedNotInvoicedContentBean;

        if (!isEmpty(packedNotInvoiceContentBean.pickedNotInvoiceInfoBean)) {
          setPackedNotInvoiceList(
            packedNotInvoiceContentBean.pickedNotInvoiceInfoBean,
          );
        }
      }
      if (!isEmpty(response.data.contentBean.shippedNotInvoicedContentBean)) {
        let shippedNotInvoicedContentBean =
          response.data.contentBean.shippedNotInvoicedContentBean;

        if (!isEmpty(shippedNotInvoicedContentBean.pickedNotInvoiceInfoBean)) {
          setShippedNotInvoiceList(
            shippedNotInvoicedContentBean.pickedNotInvoiceInfoBean,
          );
        }
      }
      // setIsLoading(false);
      setIsSummaryLoading(false);
      setIsLoadingLateCus(false);
      setIsLoadingSal_Approval(false);
      setIsLoading(false);

      setIsPackedLoading(false);
      setIsShippedLoading(false);
      setIsInvoice_UnAppLoading(false);
      setIsPurchase_AppLoading(false);

      setIsPurchase_UnAppLoading(false);
      setIsPurchase_IntransitLoading(false);
      setIsPurchase_ReceiptLoading(false);
    }
  };
  const loadDashBoardContents = () => {
    // setIsLoading(true);
    setIsSummaryLoading(true);
    setIsLoadingLateCus(true);
    setIsLoadingSal_Approval(true);
    setIsLoading(true);

    setIsPackedLoading(true);
    setIsShippedLoading(true);
    setIsInvoice_UnAppLoading(true);
    setIsPurchase_AppLoading(true);

    setIsPurchase_UnAppLoading(true);
    setIsPurchase_IntransitLoading(true);
    setIsPurchase_ReceiptLoading(true);
    UserService.getDashBoardContents("", loadDashboardResponse, errorCallBack);
  };

  useEffect(() => {
    loadDashBoardContents();
  }, []);
  const onPopupModalExit = () => {
    closeModalCallBack(false);
  };
  const closeModalCallBack = (isOpen) => {
    setIsShowSalesModule(isOpen);
    setIsShowInvoiceModule(isOpen);
    setIsShowPtModule(isOpen);
    setIsShowCustomerModule(isOpen);
    setIsShowPurchaseModule(isOpen);

    setIsShowVendorModule(isOpen);
    setIsShowIntransitModule(isOpen);
    setIsShowReceiptModule(isOpen);

    setIsShowFabricModule(isOpen);
    setIsShowCreditMemoModule(isOpen);
    setModuleForPopup([]);
  };

  const viewPtModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowPtModule(true);
        setModuleForPopup(
          <PopupPickTicketModule
            pickTicketCode={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };
  const viewSOModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowSalesModule(true);
        setModuleForPopup(
          <PopupSalesModule
            code={code}
            onModuleExit={onPopupModalExit}
            isSpecialViewMode={false}
          />,
        );
      }
    }
  };

  const viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowCustomerModule(true);
        setModuleForPopup(
          <PopupCustomerModule
            customerCode={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewPurchaseModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowPurchaseModule(true);
        setModuleForPopup(
          <PopupPurchaseOrderModule
            code={code}
            isSpecialViewMode={false}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewVendorModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowVendorModule(true);
        setModuleForPopup(
          <PopupVendorModule
            vendorCode={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewIntransitModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowIntransitModule(true);
        setModuleForPopup(
          <PopupPurchaseInTransitModule
            code={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewReceiptModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowReceiptModule(true);
        setModuleForPopup(
          <PopupPurchaseReceiptModule
            code={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowFabricModule(true);
        setModuleForPopup(
          <PopupFabricModule
            fabricStyleCode={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };

  const viewInvoiceModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        setIsShowInvoiceModule(true);
        setModuleForPopup(
          <PopupInvoiceModule
            invoiceCode={code}
            onModuleExit={onPopupModalExit}
          />,
        );
      }
    }
  };
  const formatUSD = (value) => {
    if (!value) return "$0";

    if (value >= 1000000) {
      return `$${(value / 1000000).toFixed(2)}M`;
    }

    if (value >= 1000) {
      return `$${(value / 1000).toFixed(2)}K`;
    }

    return `$${value}`;
  };
  const salesApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Salesorder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewSOModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "orderAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate#", "orderStopDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const salesUnApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Salesorder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewSOModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "orderAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate#", "orderStopDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const packedNotInvoicedColumns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Pickticket#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewPtModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Salesorder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewSOModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("PickTicketDate#", "pickTicketDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const invoiceUnApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewInvoiceModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "invoiceAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("DeliveryDate", "deliveryDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const purchaseApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Purchase#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // .setClickDetails(true, false, this.editCpm, null)
        .setClickDetails(true, false, viewPurchaseModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewVendorModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "orderAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };
  const purchaseUnApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Purchase#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // .setClickDetails(true, false, this.editCpm, null)
        .setClickDetails(true, false, viewPurchaseModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewVendorModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "orderAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };
  const purchaseIntransitColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Intransit#", "purchaseInTransitNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // .setClickDetails(true, false, this.editCpm, null)
        .setClickDetails(true, false, viewIntransitModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewVendorModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "orderAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };
  const purchaseReceiptColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // .setClickDetails(true, false, this.editCpm, null)
        .setClickDetails(true, false, viewReceiptModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewVendorModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("VendorName", "vendorName", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Amount", "receiptAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("StopDate", "orderStopDate", true, false, true)
        .setStyleDetails("left", "10", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const logisticApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Logisticorder#", "logisticOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.editCpm, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "orderQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate#", "orderDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const logisticUnApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Logisticorder#", "logisticOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.editCpm, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Quantity", "orderQuantity", true, true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("OrderDate#", "orderDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const logisticReceiptUnApprovalColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "logisticOrderReceiptNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.editCpm, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Logisticorder#", "logisticOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.editCpm, null)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("ReceiptDate", "receiptDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };

  const currentAtsColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails(is3PL ? "Item#" : "fabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        // .setClickDetails(true, false, this.editCpm, null)
        .setClickDetails(true, false, viewFabricModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Color#", "fabricStyleColorCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
      // .setClickDetails(true, false, this.editCpm, null)
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQuantity", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("ATSYard", "atsYardage", true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerOnOrdr", "customerOnOrderQuantity", true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    if (!is3PL) {
      _columns.push(
        new ColumnDefinition()
          .setDetails("VendorOnOrdr", "vendorOnOrderQuantity", true)
          .setStyleDetails("right", "", "", "wt-4", "wt-4"),
      );
    } else {
      _columns.push(
        new ColumnDefinition()
          .setDetails("LogisticOnOrdr", "logisticOnOrderQuantity", true)
          .setStyleDetails("right", "", "", "wt-4", "wt-4"),
      );
    }

    return _columns;
  };

  const lateCustomerPaymentColumns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer#", "customerCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewInvoiceModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails(
          "PaymentDueAmt",
          "paymentDueAmount",
          true,
          true,
          false,
          true,
        )
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("DueDate", "dueDate", true, false, true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("GrandTot", "grandTotalAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return _columns;
  };
  const shippedColumns = () => {
    const _columns = new Array();

    _columns.push(
      new ColumnDefinition()
        .setDetails("Pickticket#", "pickTicketNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewPtModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Salesorder#", "salesOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, viewSOModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("PickTicketDate#", "pickTicketDate", true, false, true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    return _columns;
  };
  const handleCreditMemoClick = (e)=>{
    let readRequest = new RestReadRequest();
    readRequest.companyCode = companyCode;
    CreditMemoService.getCreditMemosForDashBoard(
      readRequest,
      loadCreditMemoDetails,
      errorCallBack,
    );
 

  }
  const loadCreditMemoDetails = (response)=>{
         if (!isEmpty(response.data) && !isEmpty(response.data.creditMemoPageList)) {
      let creditMemoList = response.data.creditMemoPageList.creditMemos;
        setCreditMemoSummary(creditMemoList);
           setCreditMemoPopup(true);

    }
     
  }
  const closeAlertModalCallBack = (e) =>{
    setCreditMemoPopup(false)
  }

  const RefreshHandler = (type) => {
    if (type == 0) {
      loadDashBoardContents();
    }
    if (type == 1) {
      loadSalesApprovalPage();
    } else if (type == 2) {
      loadSalesUnApprovalPage();
    } else if (type == 3) {
      loadInvoiceUnApprovalPage();
    } else if (type == 8) {
      // loadCurrentAtsPage();
    } else if (type == 9) {
      loadLateCustomerPaymentPage();
    } else if (type == 10) {
      loadPackedNotInvoicePage();
    } else if (type == 11) {
      loadShippedNotInvoicePage();
    }
    if (!is3PL) {
      if (type == 4) {
        loadPurchaseOrderApprovalPage();
      } else if (type == 5) {
        loadPurchaseOrderUnApprovalPage();
      } else if (type == 6) {
        loadPurchaseIntransitUnApprovalPage();
      } else if (type == 7) {
        loadPurchaseReceiptUnApprovalPage();
      }
    } else {
      if (type == 4) {
        loadLogisticOrderApprovalPage();
      } else if (type == 5) {
        loadLogisticOrderUnApprovalPage();
      } else if (type == 6) {
        loadLogisticReceiptUnApprovalPage();
      }
    }
  };
  const currentMonth = new Date().toLocaleString("default", { month: "long" });

  // KPI derived values
  const openSalesOrdersCount = salesApproval.length + salesUnApproval.length;
  const lateReceivablesCount = lateCustomerPayment.length;
  const purchasePipelineCount =
    purchaseApproval.length +
    purchaseUnApproval.length +
    purchaseIntransitUnApproval.length;



    const creditMemoColumns = () => {
    const _columns = new Array();
     _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setClickDetails(true, false, viewCustomerModule, null),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "10", "", "wt-4", "wt-4"),
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CreditMemo#", "code", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false,viewCreditMemoModule, null),
    );

        _columns.push(
      new ColumnDefinition()
        .setDetails("Status", "creditMemoStatus", true)
            .setStatusDetails(true, getCaption)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
     
    );
   

    _columns.push(
      new ColumnDefinition()
        .setDetails("CreditAmount", "totalCreditAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
        _columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmount", "appliedAmount", true, true, false, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );


    return _columns;
  };
  const getCaption = (status) => {

    return ModuleUtils.getCreditMemoStatusCaption(status);
  };
    const viewCreditMemoModule = (e, code, rowData) => {

      
      if (e.detail === 1) {
        if (code !== "" && code !== undefined) {
           setIsShowCreditMemoModule(true);
                   setModuleForPopup(
          <PopupCreditMemoModule
            code={code}
            onModuleExit={onPopupModalExit}
          
          />,
        );
         
        }
      }
    };
  return (
    <div>
      <ProgressBar
        progressLoadingText={progressLoadingText}
        isShowPopup={isShowProgressBarPopup}
      />
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel0"}
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowSalesModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
        showCloseButton={false}
      ></MultiViewPopup>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel0"}
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowInvoiceModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        popupLvlClass={"popupSizeLevel0"}
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowPtModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowCustomerModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowPurchaseModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
        showCloseButton={false}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowVendorModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowIntransitModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowReceiptModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
      <MultiViewPopup
        isModulePopup={true}
        id="modulePopup"
        isShowPopup={isShowFabricModule}
        closeModalCallBack={closeModalCallBack}
        module={moduleForPopup}
      ></MultiViewPopup>
              <MultiViewPopup
                popupLvlClass={"popupSizeLevel2"}
                isModulePopup={true}
                id="modulePopup"
                isShowPopup={isShowCreditMemoPopup}
                closeModalCallBack={closeModalCallBack}
                module={moduleForPopup}
                lockScroll={true}
              ></MultiViewPopup>

         <MultiViewPopup
                popupLvlClass={"popupSizeLevel3"}
                isModulePopup={false}
                isShowPopup={showCreditMemoDetails}
                closeOnEsc={false}
                closeAlertModalCallBack={closeAlertModalCallBack}
                title={"Memo Details"}
                closeOnDocumentClick={false}
             
                lockScroll={true}

                content={
                  <div  className="db2-panel-body">
              
                    <CustomTable_v1
              columns={creditMemoColumns}
              data={creditMemoSummaryList}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isLoading}
            />
                  
                  </div>
                }
              />
      

      {/* ── Dashboard Header ── */}
      <div className="db2-header">
        <div className="db2-header-left">
          <h1 className="db2-title">Dashboard</h1>
          <p className="db2-subtitle">
            High-level view of sales, receivables, and purchasing activity.
          </p>
        </div>
        <div className="db2-header-right">
          {/* <Button className="db2-export-btn" size="sm">
            Export
          </Button> */}
          <Button
            className="db2-refresh-btn"
            size="sm"
            onClick={() => RefreshHandler(0)}
          >
            <REFRESHICON />
            &nbsp;Refresh data
          </Button>
        </div>
      </div>

    
    
<div>
{isSummaryLoading && (
  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, marginBottom: 20 }}>
    <svg width="56" height="56" viewBox="0 0 56 56">
      <circle cx="28" cy="28" r="22" fill="none"
        stroke="var(--muted)" strokeWidth="5" />
      <circle cx="28" cy="28" r="22" fill="none"
        stroke="#3b82f6" strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="138.23"
        strokeDashoffset="34.56"
        className="ring-spinning"
      />
    </svg>
    <span style={{ fontSize: 12, color: "var(--muted-foreground)" }}>
      Fetching dashboard data...
    </span>
  </div>
)}

  <div className="db2-kpi-row">
    {isSummaryLoading ? (
      <>
        <KpiSkeletonCard />
        <KpiSkeletonCard />
        <KpiSkeletonCard />
      </>
    ) : (
      <>
        <div className="db2-kpi-card">
          <div className="db2-kpi-top">
            <span className="db2-kpi-label">Sales Orders</span>
            <span className="db2-kpi-badge db2-badge-green">
              {dasboardSummary.weeklyGrowthPercentage > 0 ? "+" : ""}
              {dasboardSummary.weeklyGrowthPercentage ?? 0}% vs last week
            </span>
          </div>
          <div className="db2-kpi-value">
            {dasboardSummary.totalSalesOrders ?? 0}{" "}
            <span className="db2-kpi-unit">orders</span>
          </div>
          <div className="db2-kpi-bottom">
            <span>Pending approval</span>
            <span className="db2-kpi-badge db2-badge-red">
              {dasboardSummary.pendingSalesOrderApprovals ?? 0} critical
            </span>
          </div>
        </div>

<div className="db2-kpi-card db2-kpi-card--lr">

  {/* Top row: label + badge */}
  <div className="db2-kpi-top">
    <span className="db2-kpi-label">Late Receivables</span>
    <span className="db2-kpi-badge db2-badge-red">
      {dasboardSummary.avgLateDays ?? 0} days avg
    </span>
  </div>

  {/* Middle row: overdue value LEFT + advances box RIGHT */}
  <div className="db2-lr-body">
    <div className="db2-lr-val">
      {formatUSD(dasboardSummary.customerOverDueAmount ?? 0)}
      <span className="db2-lr-unit">overdue</span>
    </div>

    <div
      className="db2-lr-advances-box"
      // onClick={() => handleAdvancesClick()}
       onClick={() => handleCreditMemoClick("count")}
      title="Click to view available advances"
    >
      <span className="db2-lr-advances-label">Available Advances</span>
      <span className="db2-lr-advances-val">
        {formatUSD(dasboardSummary.openCreditMemoAmount ?? 0)}
      </span>
    </div>
  </div>

  {/* Bottom row: customers footer */}
  <div className="db2-lr-footer">
    <span className="db2-lr-footer-text">Customers with overdue invoices</span>
    <span className="db2-kpi-badge db2-badge-red">
      {dasboardSummary.overdueCustomers ?? 0} customers
    </span>
  </div>

</div>
        <div className="db2-kpi-card">
          <div className="db2-kpi-top">
            <span className="db2-kpi-label">Purchasing Pipeline</span>
            <span className="db2-kpi-badge db2-badge-outline">
              {currentMonth}
            </span>
          </div>
          <div className="db2-kpi-value">
            {formatUSD(dasboardSummary.purchasingAwaitingApprovalAmount ?? 0)}{" "}
            <span className="db2-kpi-unit">awaiting approval</span>
          </div>
          <div className="db2-kpi-bottom">
            <span>Average approval time</span>
            <span className="db2-kpi-badge db2-badge-outline">
              {dasboardSummary.avgApprovalDays ?? 0}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
</div>

      {/* ── Main Panel Grid ── */}
      <div className="db2-grid">
        {/* Sales Orders · Unapprovals */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Sales Orders · Unapprovals</div>
              <div className="db2-panel-desc">
                Orders pending internal approval.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(2)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={salesUnApprovalColumns}
              data={salesUnApproval}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isLoading}
            />
          </div>
        </div>

        {/* Late Customers */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Late Customers</div>
              <div className="db2-panel-desc">
                Customers with invoices past due date.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(9)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={lateCustomerPaymentColumns}
              data={lateCustomerPayment}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isLoadingLateCustomer}
            />
          </div>
        </div>

        {/* Sales Orders · Approvals */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Sales Orders · Approvals</div>
              <div className="db2-panel-desc">
                Orders approved and ready for processing.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(1)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={salesApprovalColumns}
              data={salesApproval}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isLoadingSalesApproval}
            />
          </div>
        </div>

        {/* Packed · Not Invoiced */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Packed · Not Invoiced</div>
              <div className="db2-panel-desc">
                Shipments created but invoices not issued.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(10)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={packedNotInvoicedColumns}
              data={packedNotInvoiceList}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isPackedLoading}
            />
          </div>
        </div>

        {/* Shipped · Not Invoiced */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Shipped · Not Invoiced</div>
              <div className="db2-panel-desc">
                All shipped orders are currently invoiced.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(11)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={shippedColumns}
              data={shippedNotInvoiceList}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isShippedLoading}
            />
          </div>
        </div>

        {/* Invoices · Unapprovals */}
        <div className="db2-panel">
          <div className="db2-panel-header">
            <div>
              <div className="db2-panel-title">Invoices · Unapprovals</div>
              <div className="db2-panel-desc">
                Draft invoices waiting for accounting approval.
              </div>
            </div>
            <button
              className="db2-panel-icon-btn"
              onClick={() => RefreshHandler(3)}
              title="Refresh"
            >
              {" "}
              <REFRESHICON />
            </button>
          </div>
          <div className="db2-panel-body">
            <CustomTable_v1
              columns={invoiceUnApprovalColumns}
              data={invoiceUnApproval}
              isShowFullScreen={false}
              enableVritualize={true}
              isLoading={isInvoice_UnApp}
            />
          </div>
        </div>

        {/* Purchase panels — conditional on is3PL */}
        {!is3PL ? (
          <>
            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">Purchase · Approvals</div>
                  <div className="db2-panel-desc">
                    Purchase orders awaiting approval by buying managers.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(4)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={purchaseApprovalColumns}
                  data={purchaseApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                  isLoading={isPurchase_App}
                />
              </div>
            </div>

            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">Purchase · Unapprovals</div>
                  <div className="db2-panel-desc">
                    New purchase requests not yet reviewed.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(5)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={purchaseUnApprovalColumns}
                  data={purchaseUnApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                  isLoading={isPurchase_UnApp}
                />
              </div>
            </div>

            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">
                    Purchase In-Transit · Unapprovals
                  </div>
                  <div className="db2-panel-desc">
                    No in-transit purchase issues detected.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(6)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={purchaseIntransitColumns}
                  data={purchaseIntransitUnApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                  isLoading={isPurchase_Intransit}
                />
              </div>
            </div>

            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">
                    Purchase Receipt · Unapprovals
                  </div>
                  <div className="db2-panel-desc">
                    Receipts pending confirmation.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(7)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={purchaseReceiptColumns}
                  data={purchaseReceiptUnApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                  isLoading={isPurchase_Receipt}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">Inbound · Approvals</div>
                  <div className="db2-panel-desc">
                    Inbound orders awaiting approval.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(4)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={logisticApprovalColumns}
                  data={logisticOrderApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                />
              </div>
            </div>

            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">Inbound · Unapprovals</div>
                  <div className="db2-panel-desc">
                    Inbound orders not yet reviewed.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(5)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={logisticUnApprovalColumns}
                  data={logisticOrderUnApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                />
              </div>
            </div>

            <div className="db2-panel">
              <div className="db2-panel-header">
                <div>
                  <div className="db2-panel-title">
                    Inbound Receipt · Unapprovals
                  </div>
                  <div className="db2-panel-desc">
                    Receipt confirmations pending review.
                  </div>
                </div>
                <button
                  className="db2-panel-icon-btn"
                  onClick={() => RefreshHandler(6)}
                  title="Refresh"
                >
                  {" "}
                  <REFRESHICON />
                </button>
              </div>
              <div className="db2-panel-body">
                <CustomTable_v1
                  columns={logisticReceiptUnApprovalColumns}
                  data={logisticReceiptUnApproval}
                  isShowFullScreen={false}
                  enableVritualize={true}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}


function KpiSkeletonCard() {
  return (
    <div className="db2-kpi-card">
      <div className="db2-kpi-top">
        <div className="db2-kpi-skeleton db2-kpi-skel-label" />
        <div className="db2-kpi-skeleton db2-kpi-skel-badge" />
      </div>
      <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", margin: "4px 0" }}>
        <div className="db2-kpi-skeleton db2-kpi-skel-value" />
        <div className="db2-kpi-skeleton db2-kpi-skel-unit" />
      </div>
      <div className="db2-kpi-bottom">
        <div className="db2-kpi-skeleton db2-kpi-skel-bottom" />
        <div className="db2-kpi-skeleton db2-kpi-skel-badge-sm" />
      </div>
    </div>
  );
}
